import Component from '../inherited/Component'

let jQuery = null

export default class AddToCart extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._productData = JSON.parse(this._elem.querySelector('[data-product-json]').innerHTML);
    this._options = {...{
      arrows: true,
      fade: false,
      infinite: true,
      wrapAround: true,
      slidesToShow: 1,
      slidesToScroll: 1
    }};
  }

  async mount() {
    if (window.jQuery === undefined) {
      jQuery = await import('jquery')
      jQuery = jQuery.default
    } else {
      jQuery = window.jQuery
    }
    this._upsellHandle();
  }

  _upsellHandle() {
    const addBtn = this._elem.querySelector('button[type="submit"]')
    document.querySelector('.upsell-items').classList.add('hide');
    addBtn.addEventListener('click', (event) => {
      console.log(jQuery('.upsell-slider'))
      const upsells = this._productData.upsell_products.split('|');
      const sizeAdded = document.querySelector('input[name="Size"]:checked').value.toLowerCase();
      const colorAdded = document.querySelector('input[name="Color"]:checked').value.toLowerCase();
      let url, upsell;
      let promises = [];
      for (upsell of upsells) {
        url = `/products/${upsell}?view=json`;
        promises.push(url)
      }
      Promise.all(promises.map(u => fetch(u))).then(responses =>
        Promise.all(responses.map(res => res.json()))
      ).then(posts => {
        posts.forEach(post => {
          let product_id = post.product.id;
          let product_handle = post.product.handle;
          let product_title = post.product.title;
          let variant_sizes = [];
          let has_sizes = false;
          if (post.options[1] != undefined) {
            variant_sizes = post.product.variants;
            has_sizes = true;
          }
          let variant_sizes_select = "";
          let variant_img, variant_sku, variant_id, variant_price;
          let variant_found = post.product.variants.find((e) => e.option1.toLowerCase() == colorAdded && e.option2.toLowerCase() ==  sizeAdded);
          if (has_sizes && variant_sizes.length > 0) {
            for (const variant of post.product.variants) {
              if (variant.option1.toLowerCase() == colorAdded) {
                variant_sizes_select += `<option data-variant-id=${variant.id} value="${variant.option2}">${variant.option2}</option>`;
              }
            }
          }
          //if (!variant_found) variant_found = post.product.variants.find((e) => e.option1 == o["option-0-" + o.handle] && e.option2 == o["option-1-" + o.handle]);
          if (!has_sizes) variant_found = post.product.variants.find((e) => e.option1.toLowerCase() == colorAdded);
          const productForm = document.querySelector(`.product-form--${product_handle}`);
          if (variant_found & !productForm) {
            variant_img = variant_found.featured_image.src;
            variant_sku = variant_found.sku
            variant_id = variant_found.id;
            variant_price = (variant_found.price / 100).toFixed(2);

            let html = `<product-form class="product-form product-form--${product_handle}" data-cart-upsells="">
            <div class="product-form__error-message-wrapper" role="alert" hidden="">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
                <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
              </path></svg>
              <span class="product-form__error-message"></span>
            </div><form method="post" action="/cart/add" id="upsell-form-${product_id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><div class="cart-item--rivets cart-item--upsell flex">
                <div class="left-area"> 
                    <a href="/products/${product_handle}" class="object-fit--cover"><img loading="lazy" src="${variant_img}"></a>
                </div> 
                <div class="right-area">
                    <header>
                        <a class="cart-item-product-title" href="/products/${product_handle}">${product_title}</a>
                    </header>
                    <<span class="upsell-price"><span class="money" doubly-currency-usd="${variant_price}" doubly-currency="USD">$${variant_price} USD</span></span>
                    <div class="flex input_field">
                      
                    ${has_sizes ? ` <div class="flex input_field"><select id="UpsellOptionSelector-1-${product_handle}" class="upsells-add-select" data-color-variant="${variant_found.option1}" data-index="option2">
                    <option selected="" disabled="" value="-1">ADD TO CART</option>
                    ${variant_sizes_select}
                    </select></div>`: `<button type="submit" class="add_to_cart" data-variant-id="${variant_id}" data-color-variant="${variant_found.option1}" data-action="add-to-cart">ADD TO CART</button>`}
                        <button type="submit" name="add" class="product-form__submit button upsell_add hide button--full-width button--primary" aria-haspopup="dialog">
                        <div class="loading-overlay__spinner hidden">
                          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>
                        </button>
                        
                    </div>
                  </div>
                </div>
                  <input type="hidden" name="quantity" value="1">
                  <input class="variant-id variant-id--${product_handle}" type="hidden" name="id" data-sku="${variant_sku}" value="${variant_id}">
              </form>
              </product-form>`;

              let element = this._htmlToElements(html);
              document.querySelector('.upsell-slider').appendChild(element);
              document.querySelector(`#UpsellOptionSelector-1-${product_handle}`).addEventListener('click', (event) => {
                const addBtn = document.querySelector(`.product-form--${product_handle} .product-form__submit`)
                document.querySelector(`.variant-id--${product_handle}`).setAttribute('value', event.target.getAttribute('data-variant-id'))
                console.log("DATA VARIANT ID ")
                console.log(event.target.getAttribute('data-variant-id'))
              });
          }
  
        });
      })
      setTimeout(() => {
        console.log("joinewd here!")
        console.log(this._options)
        jQuery('.upsell-slider').slick(this._options);
        document.querySelector('.upsell-items').classList.remove('hide');
      }, 2000);

    });
  }

  _htmlToElements(html) {
    let template = document.createElement('template');
    html = html.trim(); // Never return a text node of whitespace as the result
    template.innerHTML = html;
    return template.content.firstChild;
  }
}